<section class="main-wrap inner-views dashboard-wrap lens-module single-vision"
  [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>
      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>
  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
      </div>
    </div>
    <div class="content-container products-container single-product lens-module" [class]="currentParentClass">
      <div class="row">
        <div class="col-md-6">
          <div class="lens-module-data">
            <div class="collapse collapse-option3 collapse-option34">
              <div class="card-body">
                <div class="figure-wrap">
                  <img src="/assets/images/products/lens-selection/Transitions-graphics.jpg" alt="Tints Transitions" />
                </div>
              </div>
            </div>
            <div class="collapse collapse-option5 collapse-option36">
              <div class="card-body">
                <div class="figure-wrap">
                  <img src="/assets/images/products/lens-selection/Light-Gray-Tint-graphics.jpg"
                    alt="Light Gray Tint" />
                </div>
              </div>
            </div>
            <div class="collapse collapse-option4">
              <div class="card-body">
                <div class="figure-wrap">
                  <img src="/assets/images/products/lens-selection/Sun-Gray-Tint-graphics.jpg" alt="Sun Gray Tint" />
                </div>
              </div>
            </div>
            <div class="product-data-box">
              <app-product-data [tempCartEvents]="tempCartEventsSubject.asObservable()"></app-product-data>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="prod-col-in">
            <span class="back-to-previous">
              <a href="/lens-selection/options"><img height="10" src="assets/images/icons/angle-right-solid.svg"
              width="10" alt="Angle Right ICon" />Back to Lens Features</a>
            </span>
            <h2 class="prod-title">Lens Options</h2>
            <div class="progress" style="height: 7px;">
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active"
              role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active"
              role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active"
              role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar" role="progressbar"
              style="width: 25%;"></div>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 module-non-prescription">
              <h3>Tints</h3>
            </div>
            <div class="col-md-12 module-prescription-options">
              <div class="accordion" id="accordion-lens">
                <div class="card">
                  <div class="card-header" id="no-tints-transitions">
                    <input class="form-check-input lens-check" type="radio" name="radioLensSelection"
                      id="radioNoTintsTransitions" value="" aria-label="Tints Transitions" data-toggle="collapse"
                      data-target=".multi-collapse" aria-controls="noTintsTransitions noTintsTransitions2"
                      (click)="removeLensOption()">
                    <h3 class="mb-0">
                      <label aria-expanded="false" class="btn btn-link btn-block text-left collapsed form-check-label"
                        data-toggle="collapse" data-target=".multi-collapse"
                        aria-controls="noTintsTransitions noTintsTransitions2" for="radioNoTintsTransitions"
                        (click)="switchClass('noTintsTransitions')">
                        <span class="title-wrap">No Tints</span><span class="acc-price-wrap"></span>
                      </label>
                    </h3>
                  </div>
                  <div aria-labelledby="no-tints-transitions" class="collapse multi-collapse no-lens-selection"
                    data-parent="#accordion-lens" id="noTintsTransitions">
                    <div class="card-body">
                      <p></p>
                    </div>
                  </div>
                </div>
                @for (l of companyLensOptionsVM; track $index; let i = $index) {
                  <div class="card" [ngClass]="{ 'disabled': l.isDisabled}">
                    <div class="card-header" id="lens-card-header">
                      <input #option class="form-check-input lens-check" type="radio" name="radioLensSelection"
                        [attr.id]="l.lensOptionId" [disabled]="l.isDisabled" [attr.aria-label]="l.lensOptionId"
                        data-toggle="collapse" [attr.data-target]="'.multi-collapse' + l.lensOptionId"
                        [attr.aria-controls]="l.lensOptionId + '' + l.lensOptionId +'2'"
                        (click)="selectLensOption(l.lensOptionId.toString())">
                      <h3 class="mb-0">
                        <label aria-expanded="false" class="btn btn-link btn-block text-left collapsed"
                          data-toggle="collapse" [attr.data-target]="'.multi-collapse' + l.lensOptionId"
                          [attr.aria-controls]="l.lensOptionId + '' +  l.lensOptionId +'2'" type="button"
                          [attr.for]="l.lensOptionId" (click)="selectLensOption(l.lensOptionId.toString())">
                          <span class="title-wrap">{{l.lensOptionName}}</span><span class="acc-price-wrap">{{l.price |
                        currency}}</span>
                      </label>
                    </h3>
                  </div>
                  <div [attr.aria-labelledby]="l.lensOptionId"
                    [attr.class]="'collapse multi-collapse' + l.lensOptionId" data-parent="#accordion-lens"
                    [attr.id]="l.lensOptionId">
                    <div class="card-body">
                      <p>
                        {{l.lensOptionDescription}}
                      </p>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="col-md-12 module-nav next-step">
            <button class="btn product-btn gray-btn" [routerLink]="['/lens-selection/options']"
              [queryParams]="queryParams" type="button">Back
            </button>
            <button class="btn product-btn gray-btn" [disabled]="!optionSelected"
              [routerLink]="['/lens-selection/options']" [queryParams]="queryParams" type="button">Next
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</section>
